import React from 'react';
import { Base, Button, Menu, MenuBar, MenuItem, } from '@stepstone-genesis/components';
import { EllipsesIcon, WarningIcon } from '@stepstone-genesis/icons';
import labels from 'modules/hub/components/AMAChat/constants/labels/ama';
const COMPONENT_ID = 'companyHubHeader';
// Mirrors @stepstone/job-ad-components' ControlMenu + DigitalServiceAct's
// ReportButton (the "⋮" menu next to Apply/Save on job ads): a MenuBar whose
// disclosure is an ellipsis icon button, revealing a single MenuItem linking
// out to the DSA report form.
const ReportButton = ({ url, lang, companyId }) => {
    const { reportProblemLinkText: reportLabel } = labels[lang];
    return (React.createElement(Base, { sx: {
            alignSelf: 'flex-end',
            zIndex: 'zIndex10',
        } },
        React.createElement(MenuBar, null,
            React.createElement(Menu, { disclosure: React.createElement(Button, { a11yLabel: "reveal dsa report button", sx: {
                        '&&': {
                            '&:active, &:hover': {
                                backgroundColor: 'colorWhite',
                            },
                        },
                        backgroundColor: 'transparent',
                    } },
                    React.createElement(EllipsesIcon, { size: "large", color: "colorIconPositiveStrongDefault" })), placement: "bottom-end", size: "small" },
                React.createElement(MenuItem, { href: url },
                    React.createElement(Button, { a11yLabel: reportLabel, "data-testid": "report-button", "data-atx-component": COMPONENT_ID, "data-atx-onclick-payload": JSON.stringify({
                            linkName: 'reportJobClick',
                            componentId: COMPONENT_ID,
                            elementActioned: 'reportButton',
                            elementAction: 'Click',
                            elementActionValue: 'noValue',
                            companyId: companyId ?? 'noValue',
                        }), iconBefore: React.createElement(WarningIcon, { color: "colorGreyDarker", size: "small" }), variant: "linkSecondary", size: "xs" }, reportLabel))))));
};
export default ReportButton;
